module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5679cd29c517886712116060d3360592.svg";